<template>
	<div v-html="fixedHtml" id="wc-power-page" />
</template>

<script>
import { prerender } from 'staticData';
import { fixRelativeLinks } from 'utils';
let hasLoadedWebcollageScript = false;
let hasLoadedWCPowerPageOnce = false;

export default {
	props: {
		html: {
			type: String,
			default: '',
		},
		product: {
			type: Object,
			required: true,
		},
	},
	mounted () {
		this.$nextTick(() => {
			if (! prerender) {
				this.loadDynamicContent();
			}
			fixRelativeLinks(this.$el);
		});
	},
	beforeDestroy() {
		this.destroyDynamicContent();
	},
	computed: {
		fixedHtml () {
			const oldFyndwareUrl = 'http://www.webhallen.com/info/support_och_retur/fyndvaror';
			return this.html
				.replace(/\\"/g, '"')
				.replace(/\\'/g, '\'')
				.replace(/<img src='bilder\/utrop.gif' height='10' width='10' border='0'>(\s+)<b>För mer info om produkten, gå till tillverkarens hemsida. Länken hittar du nedanför denna text.<\/b>/g, '')
				.replace(/\n/g, '<br />')
				.replace('<a href=\'' + oldFyndwareUrl + '\'>' + oldFyndwareUrl + ' </a>', '<a href="/se/info/11-Fyndvaror">Fyndvaror</a>');
			// @TODO Vi kan göra detta i backend så blir det cacheat
		},
	},
	methods: {
		loadDynamicContent () {
			const p = this.product;
			switch (p.descriptionProvider) {
				case 1:
					this.fixFlix(p);
					break;
				case 2:
					this.fixWebcollage();
					break;
				case 3:
					this.fixCnet(p);
					break;
			}
		},
		destroyDynamicContent () {
			if (window.Webcollage && Webcollage.terminatePowerPage) {
				Webcollage.terminatePowerPage();
			}
		},
		fixFlix (p) {
			let mf = null;
			let pn = null;
			let ean = null;

			if (p.manufacturer && p.manufacturer.name) {
				mf = p.manufacturer.name;
			}
			if (p.partNumbers && p.partNumbers.length) {
				pn = p.partNumbers[0];
			}
			if (p.eans && p.eans.length) {
				ean = p.eans[0];
			}

			var url = 'https://media.flixfacts.com/js/loader.js';

			const sc = document.createElement('script');
			sc.type = 'text/javascript';
			sc.src = url;
			sc.setAttribute('data-flix-distributor', '294');
			sc.setAttribute('data-flix-language', 'sv');
			sc.setAttribute('data-flix-brand', mf);
			sc.setAttribute('data-flix-mpn', pn);
			sc.setAttribute('data-flix-ean', ean);
			sc.setAttribute('data-flix-sku', p.id);
			sc.setAttribute('data-flix-button', 'flix-minisite');
			sc.setAttribute('data-flix-inpage', 'wc-power-page');

			sc.onload = () => {
				sc.parentNode.removeChild(sc);
			};

			document.head.appendChild(sc);
		},
		fixWebcollage () {
			var url = '//scontent.webcollage.net/api/v2/product-content';

			const sc = document.createElement('script');
			sc.type = 'text/javascript';
			sc.src = url;

			if (hasLoadedWebcollageScript) {
				this.$nextTick(() => {
					this.loadWebcollageContent();
				});
				return;
			}

			sc.onload = () => {
				hasLoadedWebcollageScript = true;
				this.loadWebcollageContent();
				sc.parentNode.removeChild(sc);
			};

			document.head.appendChild(sc);
		},
		loadWebcollageContent () {
			this.destroyDynamicContent();
			Webcollage.loadProductContent('webhallen-se', this.product.id+'', {'power-page': {
				autoPlayAndStop: true,
				// hasPowerPageContentCallback: res => console.log('WC has content!', res),
				noPowerPageContentCallback: res => console.log('WC has no content!'),
				reload: hasLoadedWCPowerPageOnce,
			}});
			hasLoadedWCPowerPageOnce = true;
		},
		fixCnet (p) {
			let mf = null;
			let pn = null;
			if (p.manufacturer && p.manufacturer.name && p.partNumbers && p.partNumbers.length) {
				mf = p.manufacturer.name;
				pn = p.partNumbers[0];
			}

			var url = 'https://ws.cs.1worldsync.com/9cccecca/script/d8dfd50bfd?lang=sv&market=se';

			if (pn) {
				url += '&mf=' +
					encodeURIComponent(mf) +
					'&pn=' +
					encodeURIComponent(pn);
			} else {
				url += '&cpn=' + p.id;
			}

			// Getting new portion of content
			var sc = document.createElement('script');
			sc.type = 'text/javascript';
			sc.onload = function() { this.parentNode.removeChild(this); }
			sc.src = url;
			var n = document.getElementsByTagName('script')[0];
			n.parentNode.insertBefore(sc, n);
		},
		fixRelativeLinks () {
			// Fixa länkar
			const baseURL = window.location.protocol + '//' + window.location.hostname;
			const baseURLLength = baseURL.length;
			const links = this.$el.querySelectorAll('a');
			for (const link of links) {
				if (link.href.indexOf(baseURL) === 0) {
					if (link.hash) {
						link.onclick = () => {
							scrollTo(link.hash);
							return false;
						};
						continue;
					}
					link.onclick = () => {
						this.$router.push(link.href.slice(baseURLLength));
						return false;
					};
				}
			}
		},
	},
	watch: {
		html () {
			this.$nextTick(() => {
				fixRelativeLinks(this.$el);
				this.loadDynamicContent();
			});
		},
	},
};
</script>
